import React, { useState, useEffect } from 'react';
import 'antd/dist/antd.min.css';
import { Drawer, Button, Form, Input, message, Upload, Spin } from 'antd';

import { editHelpContent } from 'services/help.js';
import {
    MenuOutlined,
    InboxOutlined,
    DownOutlined,
    SmileOutlined
} from '@ant-design/icons';
import Loader from 'components/Loader';

const { Dragger } = Upload;

const EditDrawer = (props) => {
    const [form] = Form.useForm();
    const [isFileUploaded, setIsFileUploaded] = useState(false);
    const [newImage, setNewImage] = useState(false);
    useEffect(() => {
        form.setFieldsValue(props.editData);
    }, [props.editData]);

    const { TextArea } = Input;

    const onFinish = (values) => {
        editHelpContent(props.editData.id, values.title, values.description);
        props.setVisibleEditDrawerHelp(false);
        setInterval(() => {
            props.setRerenderTableAfterChangeData(
                !props.rerenderTableAfterChangeData
            );
        }, 1000);
    };

    const propsDragger = {
        name: 'image',
        multiple: false,
        method: 'PATCH',
        action: `${process.env.REACT_APP_API_URL}/api/v1/generic/help-content/${props.editData.id}/`,

        headers: {
            Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`
        },
        // onSuccess: () => {
        //     let newOrder = [];

        //     for (let i in data) {
        //         let item = data[i];
        //         newOrder.push(item.id);
        //     }
        //     console.log(`newOrder`, newOrder);
        //     setHelpContentOrder(newOrder);
        // },

        beforeUpload: () => {
            setIsFileUploaded(true);
            return new Promise((r) => setTimeout(r, 2000));
        },

        onPreview: () => {
            setIsFileUploaded(true);
        },

        onChange(info) {
            const { status } = info.file;

            if (status !== 'uploading') {
                console.log(info.file, info.fileList);
            }

            if (status === 'done') {
                setIsFileUploaded(false);
                message.success(
                    `${info.file.name} file uploaded successfully.`
                );

                setNewImage(info.file.response.image);
            } else if (status === 'error') {
                setIsFileUploaded(false);
                message.error(`${info.file.name} file upload failed.`);
            }
        },

        onDrop(e) {
            // setIsFileUploaded(false);
            console.log('Dropped files', e.dataTransfer.files);
        }
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <>
            <Drawer
                title={`Edit ${props.editData.title}`}
                placement="right"
                onClose={props.onCloseEditDrawerHelp}
                visible={props.visibleEditDrawerHelp}
                width={400}
                className="drawer-edit-help"
            >
                <Form
                    form={form}
                    name="basic"
                    labelCol={{
                        span: 8
                    }}
                    wrapperCol={{
                        span: 16
                    }}
                    initialValues={{
                        remember: true
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Title"
                        name="title"
                        rules={[
                            {
                                required: true,
                                message: 'Please input Title here!'
                            }
                        ]}
                    >
                        <Input defaultValue={props.editData.title} />
                    </Form.Item>

                    <Form.Item
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        label="Description"
                        name="description"
                        rules={[
                            {
                                required: true,
                                message: 'Please Input Description'
                            }
                        ]}
                    >
                        <TextArea
                            defaultValue={props.editData.description}
                            rows={4}
                        />
                    </Form.Item>

                    <Form.Item
                    // wrapperCol={{
                    //     offset: 8,
                    //     span: 16
                    // }}
                    >
                        <Button type="primary" htmlType="submit">
                            Save
                        </Button>
                    </Form.Item>
                </Form>

                <div style={{ marginTop: '50px' }}>
                    <div style={{ marginBottom: '20px' }}>Image Preview:</div>
                    <img
                        src={newImage ? newImage : props.editData.image}
                        style={{
                            width: '100%'
                            // border: '1px solid #73aaed'
                        }}
                        alt=""
                    />
                    <div style={{ marginTop: '20px' }}></div>
                    <Dragger
                        showUploadList={false}
                        {...propsDragger}
                        style={{ marginBottom: '30px' }}
                    >
                        {isFileUploaded ? (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    height: '141px'
                                }}
                            >
                                {/* <Spin size="large" /> */}
                                <Loader />
                            </div>
                        ) : (
                            <>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                                <p className="ant-upload-hint">
                                    Support for a single or bulk upload.
                                    Strictly prohibit from uploading company
                                    data or other band files
                                </p>
                            </>
                        )}
                    </Dragger>
                </div>
            </Drawer>
        </>
    );
};

export default EditDrawer;
